import axios from 'axios';
import router from '../router';

let state = {
    motorData: null,
    tractionSheaveData: null,
    motorAxleLoad: null,
    frameMountingSelection: [],
    selectedFrameMounting: undefined,
    fraartSelection: [],
    selectedFraart: null,
    fratypSelection: [],
    selectedFratyp: null,
    urdSelection: [],
    selectedUrd: null,
    positionInformation: {},
    positionUniversal: null,
    positionLeft: null,
    positionRight: null,
    frameDetails: null,
    urzSelection: [],
    pulleyDetails: null,
    selectedUrz: null,

    motorSelection: [],
    selectedMotorElement: null,
    tractionSheaveDiameterSelection: [],
    selectedTractionSheaveDiameterElement: null,

    lur: false,
    optionRetrofit: false,
    optionEmergencyStop: false,
    optionRopeGuard: false,
    optionIsolation: false,
    balSelection: [],
    mkSelection: [],
    selectedBal: null,
    selectedMk: null,
    optionRetrofitAvailable: false,
    optionEmergencyStopAvailable: false,
    optionRopeGuardAvailable: false,
    optionIsolationAvailable: false,
    balAvailable: false,
    mkAvailable: false,
}


const actions = {
    async get_allFrameDetails_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        var frames = null;
        if (state.frame_Data.hasOwnProperty('frame_Selection') && state.frame_Data.frame_Selection.length > 0) {
            const firstIndex_frameSelected = state.frame_Data.frame_Selection.findIndex(i => (i.selected == true))

            if (firstIndex_frameSelected > -1) {
                frames = state.frame_Data.frame_Selection[firstIndex_frameSelected].frame;
            }
        }
        var motorSelected = state.motorData != null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            frame: frames,
            motorSelected: motorSelected,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_allFrameDetails',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data.valid == true) {
                    commit('change_urdSelection_storeMutation', response.data.urdSelection);
                    const firstIndex_whichMeetConditions = state.urdSelection.findIndex(i => (i.selected == true));
                    if (firstIndex_whichMeetConditions > -1) {
                        commit('change_urdSelected_storeMutation', state.urdSelection[firstIndex_whichMeetConditions].value);
                    }
                    commit('change_positionInformation_storeMutation', response.data.positionInformation);
                    commit('change_positionUniversal_storeMutation', state.positionInformation.universalDefault);
                    commit('change_positionLeft_storeMutation', state.positionInformation.leftDefault);
                    commit('change_positionRight_storeMutation', state.positionInformation.rightDefault);
                    commit('change_frameDetails_storeMutation', response.data.frameDetails);
                    dispatch('get_urzSelection_storeAction');
                    dispatch('get_frameOptions_storeAction');
                }
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async get_motorInformation_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_motorInformation',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data.motorSelected == true && response.data != null && response.data.motor != null && response.data.motor != '') {
                    commit('change_motorData_storeMutation', response.data.motor);
                    commit('change_tractionSheaveData_storeMutation', response.data.tractionSheave)
                    commit('change_motorAxleLoad_storeMutation', response.data.motorAxleLoad);
                    dispatch('get_fraartSelection_storeAction');
                    dispatch('get_frameMountingSelection_storeAction');
                }
                else if (response.data.motorSelected == false) {
                    commit('change_motorSelection_storeMutation', response.data.motorSelection);
                    var firstIndex_whichMeetConditions = state.motorSelection.findIndex(i => (i.selected == true));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_Selected_motor_storeAction', state.motorSelection[firstIndex_whichMeetConditions]);
                    }
                    commit('change_tractionSheaveDiameterSelection_storeMutation', response.data.tractionSheaveDiameterSelection);
                    firstIndex_whichMeetConditions = state.tractionSheaveDiameterSelection.findIndex(i => (i.selected == true));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_Selected_tractionSheaveDiameter_storeAction', state.tractionSheaveDiameterSelection[firstIndex_whichMeetConditions]);
                    }
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_frameMountingSelection_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        };
        await axios({
            method: 'post',
            url: '/api/frameManual/get_frameMountingSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_frameMountingSelection_storeMutation', response.data);
                dispatch('change_Selected_frameMountingValue_storeAction');
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_fraartSelection_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            motorSelected: motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_fraartSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_fraartSelection_storeMutation', response.data);
                const firstIndex_whichMeetConditions = state.fraartSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions > -1) {
                    dispatch('change_Selected_fraart_storeAction', state.fraartSelection[firstIndex_whichMeetConditions]);
                }
                //dispatch('get_motorInformation_storeAction');
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async get_fratypSelection_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            motorSelected: motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_fratypSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_fratypSelection_storeMutation', response.data);
                const firstIndex_whichMeetConditions = state.fratypSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions > -1) {
                    dispatch('change_Selected_fratyp_storeAction', state.fratypSelection[firstIndex_whichMeetConditions]);
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_urdSelection_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;
        const fratyp = state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text') ? state.selectedFratyp.text.text : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            fratyp: fratyp,
            motorSelected: motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_urdSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_urdSelection_storeMutation', response.data);
                const firstIndex_whichMeetConditions = state.urdSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions > -1) {
                    dispatch('change_Selected_urd_storeAction', state.urdSelection[firstIndex_whichMeetConditions]);
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async get_positionSelection_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;
        const fratyp = state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text') ? state.selectedFratyp.text.text : null;

        const urd = state.selectedUrd != null && state.selectedUrd.hasOwnProperty('value') ? state.selectedUrd.value : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            fratyp: fratyp,
            urd: urd,
            motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_positionInformation',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_positionInformation_storeMutation', response.data);
                dispatch('change_positionPulley_storeAction', state.positionInformation);

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async get_frameDetails_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;
        const fratyp = state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text') ? state.selectedFratyp.text.text : null;

        const urd = state.selectedUrd != null && state.selectedUrd.hasOwnProperty('value') ? state.selectedUrd.value : null;

        const positionUniversal = state.positionUniversal != null ? state.positionUniversal : null;
        const positionLeft = state.positionLeft != null ? state.positionLeft : null;
        const positionRight = state.positionRight != null ? state.positionRight : null;

        if (fratyp != null) {
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                fraart: fraart,
                fratyp: fratyp,
                urd: urd,
                positionUniversal: positionUniversal,
                positionLeft: positionLeft,
                positionRight: positionRight,
                motorSelected: motorSelected,
                mtyp: mtyp,
                mbg: mbg,
                mfe: mfe,
                tsd: tsd,
            };

            await axios({
                method: 'post',
                url: '/api/frameManual/get_frameDetails',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    commit('change_frameDetails_storeMutation', response.data);

                })
                .catch(() => { })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },

    async get_urzSelection_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;
        const fratyp = state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text') ? state.selectedFratyp.text.text : null;

        const urd = state.selectedUrd != null && state.selectedUrd.hasOwnProperty('value') ? state.selectedUrd.value : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            fratyp: fratyp,
            urd: urd,
            motorSelected: motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
            ra: null,
            rz: null,
            sd: null,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_urzSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_urzSelection_storeMutation', response.data);
                const firstIndex_whichMeetConditions = state.urzSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions > -1) {
                    dispatch('change_Selected_urz_storeAction', state.urzSelection[firstIndex_whichMeetConditions]);
                }
                if (state.urzSelection.length == 0) {
                    commit('change_lur_storeMutation', false);
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async get_pulleyDetails_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;
        const fratyp = state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text') ? state.selectedFratyp.text.text : null;

        const urd = state.selectedUrd != null && state.selectedUrd.hasOwnProperty('value') ? state.selectedUrd.value : null;
        const urz = state.selectedUrz != null ? state.selectedUrz.value : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            fratyp: fratyp,
            urd: urd,
            urz: urz,
            motorSelected: motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
            ra: null,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_pulleyDetails',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_pulleyDetails_storeMutation', response.data);

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_frameOptions_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var motorSelected = state.motorData != null;
        const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
        const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
        const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
        const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

        const fraart = state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text') ? state.selectedFraart.text.text : null;
        const fratyp = state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text') ? state.selectedFratyp.text.text : null;

        const urd = state.selectedUrd != null && state.selectedUrd.hasOwnProperty('value') ? state.selectedUrd.value : null;
        const positionLeft = state.positionLeft != null ? state.positionLeft : null;
        const positionRight = state.positionRight != null ? state.positionRight : null;

        const data = {
            kid: rootState.manualHome.kid,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            fratyp: fratyp,
            urd: urd,
            positionLeft: positionLeft,
            positionRight: positionRight,
            motorSelected: motorSelected,
            mtyp: mtyp,
            mbg: mbg,
            mfe: mfe,
            tsd: tsd,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_frameOptions',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_optionRetrofit_storeMutation', response.data.optionRetrofitDefault);
                commit('change_optionEmergencyStop_storeMutation', response.data.optionEmergencyStopDefault);
                commit('change_optionRopeGuard_storeMutation', response.data.optionRopeGuardDefault);
                commit('change_optionIsolation_storeMutation', response.data.optionIsolationDefault);
                commit('change_optionRetrofitAvailable_storeMutation', response.data.optionRetrofitAvailable);
                commit('change_optionEmergencyStopAvailable_storeMutation', response.data.optionEmergencyStopAvailable);
                commit('change_optionRopeGuardAvailable_storeMutation', response.data.optionRopeGuardAvailable);
                commit('change_optionIsolationAvailable_storeMutation', response.data.optionIsolationAvailable);

                commit('change_balSelection_storeMutation', response.data.balSelection);
                const firstIndex_whichMeetConditions_bal = state.balSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions_bal > -1) {
                    commit('change_selectedBal_storeMutation', state.balSelection[firstIndex_whichMeetConditions_bal]);
                }
                commit('change_balAvailable_storeMutation', response.data.balAvailable);
                commit('change_mkSelection_storeMutation', response.data.mkSelection);
                const firstIndex_whichMeetConditions_mk = state.mkSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions_mk > -1) {
                    dispatch('change_Selected_mk_storeAction', state.mkSelection[firstIndex_whichMeetConditions_mk]);
                }
                commit('change_mkAvailable_storeMutation', response.data.mkAvailable);
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    change_Selected_motor_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_motorSelected_storeMutation', null);
        }
        else {
            commit('change_motorSelected_storeMutation', value.text);
        }
        dispatch('changed_frameManualSelection_toDefault');
    },
    change_Selected_tractionSheaveDiameter_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_tractionSheaveDiameterSelected_storeMutation', null);
        }
        else {
            commit('change_tractionSheaveDiameterSelected_storeMutation', value);
        }

        dispatch('changed_frameManualSelection_toDefault');
        if (state.selectedTractionSheaveDiameterElement != null && state.selectedTractionSheaveDiameterElement.tsd != null) {
            dispatch('get_fraartSelection_storeAction');
            //dispatch('get_frameMountingSelection_storeAction');
        }
    },
    change_Selected_frameMounting_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_frameMountingSelected_storeMutation', null);
        }
        else {
            commit('change_frameMountingSelected_storeMutation', value.blockNumber);
        }

        dispatch('change_Selected_frameMountingValue_storeAction');
    },
    change_Selected_frameMountingValue_storeAction({ commit, dispatch }, value) {
        const firstIndex_whichMeetConditions = state.frameMountingSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            commit('change_selectedFrameMounting_storeMutation', state.frameMountingSelection[firstIndex_whichMeetConditions])
        }
        else {
            commit('change_selectedFrameMounting_storeMutation', null);
        }
    },
    change_Selected_fraart_storeAction({ commit, dispatch }, value) {
        dispatch('change_fratyp_toDefault');
        dispatch('change_urd_toDefault');
        dispatch('change_position_toDefault');
        dispatch('change_frameDetails_toDefault');
        dispatch('change_urz_toDefault');
        dispatch('change_pulleyDetails_toDefault');
        dispatch('change_frameOptions_toDefault');

        if (value != null && value.hasOwnProperty('text')) {
            commit('change_fraartSelected_storeMutation', value.text.text);
            dispatch('get_fratypSelection_storeAction');
        }
        else {
            commit('change_fraartSelected_storeMutation', null);
        }
    },
    change_Selected_fratyp_storeAction({ commit, dispatch }, value) {
        dispatch('change_frameOptions_toDefault');
        dispatch('change_urd_toDefault')
        dispatch('change_position_toDefault');
        dispatch('change_frameDetails_toDefault');
        dispatch('change_urz_toDefault');
        dispatch('change_pulleyDetails_toDefault');

        if (value != null && value.hasOwnProperty('text')) {
            commit('change_fratypSelected_storeMutation', value.text.text);
            if (value.pulleyAvailable == true) {
                dispatch('get_urdSelection_storeAction');
                commit('change_lur_storeMutation', value.lurDefault);
            }
            else {
                dispatch('get_frameOptions_storeAction');
                commit('change_lur_storeMutation', false);
                dispatch('get_frameDetails_storeAction');
            }
        }
        else {
            commit('change_fratypSelected_storeMutation', null);
            commit('change_lur_storeMutation', false);
        }
    },
    change_Selected_urd_storeAction({ commit, dispatch }, value) {
        dispatch('change_position_toDefault');
        dispatch('change_frameDetails_toDefault');
        dispatch('change_urz_toDefault');
        dispatch('change_pulleyDetails_toDefault');
        dispatch('change_frameOptions_toDefault');

        if (value != null && value.hasOwnProperty('value')) {
            commit('change_urdSelected_storeMutation', value.value);
            dispatch('get_positionSelection_storeAction');
            //    dispatch('get_urzSelection_storeAction');
            //    dispatch('get_frameOptions_storeAction');
        }
        else {
            commit('change_urdSelected_storeMutation', null);
        }
    },
    change_Selected_position_storeAction({ commit, dispatch }, value) {
        if (value == 'universal') {
            commit('change_positionUniversal_storeMutation', 1)
            commit('change_positionLeft_storeMutation', 0)
            commit('change_positionRight_storeMutation', 0)
            dispatch('get_frameDetails_storeAction');
            dispatch('get_urzSelection_storeAction');
            dispatch('get_frameOptions_storeAction');
        }
        else if (value == 'left') {
            commit('change_positionUniversal_storeMutation', 0)
            commit('change_positionLeft_storeMutation', 1)
            commit('change_positionRight_storeMutation', 0)
            dispatch('get_frameDetails_storeAction');
            dispatch('get_urzSelection_storeAction');
            dispatch('get_frameOptions_storeAction');
        }
        else if (value == 'right') {
            commit('change_positionUniversal_storeMutation', 0)
            commit('change_positionLeft_storeMutation', 0)
            commit('change_positionRight_storeMutation', 1)
            dispatch('get_frameDetails_storeAction');
            dispatch('get_urzSelection_storeAction');
            dispatch('get_frameOptions_storeAction');

        }
        else {
            commit('change_positionLeft_storeMutation', 0)
            commit('change_positionRight_storeMutation', 0)
            dispatch('change_frameDetails_toDefault');
            dispatch('change_frameOptions_toDefault');
        }
    },
    change_positionPulley_storeAction({ commit, dispatch }, value) {
        commit('change_positionUniversal_storeMutation', value.universalDefault);
        commit('change_positionLeft_storeMutation', value.leftDefault);
        commit('change_positionRight_storeMutation', value.rightDefault);
        dispatch('get_frameDetails_storeAction');
        dispatch('get_urzSelection_storeAction');
        dispatch('get_frameOptions_storeAction');
    },
    change_Selected_urz_storeAction({ commit, dispatch }, value) {
        dispatch('change_pulleyDetails_toDefault');

        if (value != null && value.hasOwnProperty('value')) {
            commit('change_urzSelected_storeMutation', value.value);
            dispatch('get_pulleyDetails_storeAction');
        }
        else {
            commit('change_urzSelected_storeMutation', null);
        }
    },
    change_lur_storeAction({ commit, dispatch }, value) {
        commit('change_lur_storeMutation', value);
        dispatch('change_Selected_urz_storeAction', null);
    },
    change_optionRetrofit_storeAction({ commit }, value) {
        commit('change_optionRetrofit_storeMutation', value);
    },
    change_optionEmergencyStop_storeAction({ commit }, value) {
        commit('change_optionEmergencyStop_storeMutation', value);
    },
    change_optionRopeGuard_storeAction({ commit }, value) {
        commit('change_optionRopeGuard_storeMutation', value);
    },
    change_optionIsolation_storeAction({ commit }, value) {
        commit('change_optionIsolation_storeMutation', value);
    },
    change_balSelection_storeAction({ commit }, value) {
        commit('change_balSelection_storeMutation', value);
    },
    change_mkSelection_storeAction({ commit }, value) {
        commit('change_mkSelection_storeMutation', value);
    },
    change_Selected_bal_storeAction({ commit, dispatch }, value) {
        if (value != null && value.hasOwnProperty('text')) {
            commit('change_balSelected_storeMutation', value);
        }
        else {
            commit('change_balSelected_storeMutation', null);
        }
    },
    change_Selected_mk_storeAction({ commit, dispatch }, value) {
        if (value != null && value.hasOwnProperty('text')) {
            commit('change_mkSelected_storeMutation', value.text.text);
        }
        else {
            commit('change_mkSelected_storeMutation', null);
        }
    },

    changed_frameManual_toDefault({ commit, dispatch }) {
        dispatch('change_fraart_toDefault');
        dispatch('change_fratyp_toDefault');
        dispatch('change_urd_toDefault');
        dispatch('change_position_toDefault');
        dispatch('change_frameDetails_toDefault')
        dispatch('change_urz_toDefault');
        dispatch('change_pulleyDetails_toDefault');
        dispatch('change_frameOptions_toDefault');
        commit('change_motorData_storeMutation', null);
        commit('change_tractionSheaveData_storeMutation', null);
        commit('change_motorAxleLoad_storeMutation', null);
        commit('change_selectedFrameMounting_storeMutation', null);
        commit('change_frameMountingSelection_storeMutation', []);

        commit('change_motorSelection_storeMutation', []);
        commit('change_tractionSheaveDiameterSelection_storeMutation', []);

    },
    changed_frameManualSelection_toDefault({ commit, dispatch }) {
        dispatch('change_fraart_toDefault');
        dispatch('change_fratyp_toDefault');
        dispatch('change_urd_toDefault');
        dispatch('change_position_toDefault');
        dispatch('change_frameDetails_toDefault')
        dispatch('change_urz_toDefault');
        dispatch('change_pulleyDetails_toDefault');
        dispatch('change_frameOptions_toDefault');
        commit('change_motorData_storeMutation', null);
        commit('change_tractionSheaveData_storeMutation', null);
        commit('change_motorAxleLoad_storeMutation', null);
        commit('change_selectedFrameMounting_storeMutation', null);
        commit('change_frameMountingSelection_storeMutation', []);
    },
    change_fraart_toDefault({ commit }) {
        commit('change_fraartSelection_storeMutation', []);
        commit('change_selectedFraart_storeMutation', null);
    },
    change_fratyp_toDefault({ commit }) {
        commit('change_fratypSelection_storeMutation', []);
        commit('change_selectedFratyp_storeMutation', null);
        commit('change_lur_storeMutation', false)
    },
    change_urd_toDefault({ commit }) {
        commit('change_urdSelection_storeMutation', []);
        commit('change_selectedUrd_storeMutation', null);
    },
    change_position_toDefault({ commit }) {
        commit('change_positionInformation_storeMutation', []);
        commit('change_positionUniversal_storeMutation', null);
        commit('change_positionLeft_storeMutation', null);
        commit('change_positionRight_storeMutation', null);
    },
    change_frameDetails_toDefault({ commit }) {
        commit('change_frameDetails_storeMutation', []);
    },
    change_urz_toDefault({ commit }) {
        commit('change_urzSelection_storeMutation', []);
        commit('change_selectedUrz_storeMutation', null);
    },
    change_pulleyDetails_toDefault({ commit }) {
        commit('change_pulleyDetails_storeMutation', []);
    },
    change_frameOptions_toDefault({ commit }) {
        commit('change_optionRetrofit_storeMutation', false);
        commit('change_optionEmergencyStop_storeMutation', false);
        commit('change_optionRopeGuard_storeMutation', false);
        commit('change_optionIsolation_storeMutation', false);
        commit('change_optionRetrofitAvailable_storeMutation', false);
        commit('change_optionEmergencyStopAvailable_storeMutation', false);
        commit('change_optionRopeGuardAvailable_storeMutation', false);
        commit('change_optionIsolationAvailable_storeMutation', false);

        commit('change_balSelection_storeMutation', []);
        commit('change_balAvailable_storeMutation', false);
        commit('change_selectedBal_storeMutation', null);
        commit('change_mkSelection_storeMutation', []);
        commit('change_mkAvailable_storeMutation', false);
        commit('change_selectedMk_storeMutation', null);

    },

    checkIf_frameManual_areValid_storeAction({ rootState, dispatch }) {
        var numberOf_inputs_whichAreInvalid = 0;
        var fraart = null;
        if (state.selectedFraart != null && state.selectedFraart.hasOwnProperty('text')) {
            fraart = state.selectedFraart.text.text;
        }

        var fratyp = null;
        if (state.selectedFratyp != null && state.selectedFratyp.hasOwnProperty('text')) {
            fratyp = state.selectedFratyp.text.text;
        }
        var urd = null;
        if (state.selectedUrd != null && state.selectedUrd.hasOwnProperty('value')) {
            urd = state.selectedUrd.value;
        }
        if (state.lur != null &&
            state.lur != false &&
            (state.pulleyDetails == null || state.pulleyDetails.pulleyId == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (fraart != null && (state.frameDetails == null || state.frameDetails.frameId == null)){
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (fraart != null && fraart.hasOwnProperty('text') && fraart == true) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (fratyp != null && fratyp.hasOwnProperty('text') && fratyp == true) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (state.mkAvailable == true) {
            if (state.selectedMk == null || state.selectedMk.hasOwnProperty('text') == false || state.selectedMk.selected == false) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
        }
        if (state.balSelection != null && state.balSelection.length > 0 && (state.selectedBal == null || state.selectedBal.selected == false)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (numberOf_inputs_whichAreInvalid > 0) {
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1446 }, { textKey: 1449 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            dispatch('insertOrUpdate_frameManual_storeAction')
        }
    },

    async insertOrUpdate_frameManual_storeAction({ rootState, dispatch }) {
        if (state.selectedFraart != null || state.selectedFrameMounting != null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            var motorSelected = state.motorData != null;
            const mtyp = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mtyp : null;
            const mbg = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mbg : null;
            const mfe = motorSelected == false && state.selectedMotorElement != null ? state.selectedMotorElement.mfe : null;
            const tsd = motorSelected == false && state.selectedTractionSheaveDiameterElement != null ? state.selectedTractionSheaveDiameterElement.tsd : null;

            var frameManual = {};
            frameManual.fraart = (state.selectedFraart != null) ? state.selectedFraart.text.text : null;
            frameManual.fratyp = (state.selectedFratyp != null) ? state.selectedFratyp.text.text : null;
            frameManual.urd = (state.selectedUrd != null) ? state.selectedUrd.value : null;
            frameManual.urz = (state.selectedUrz != null) ? state.selectedUrz.value : null;
            frameManual.urd = (state.selectedUrd != null) ? state.selectedUrd.value : null;
            frameManual.positionUniversal = (state.positionUniversal != null) ? state.positionUniversal : null;
            frameManual.positionLeft = (state.positionLeft != null) ? state.positionLeft : null;
            frameManual.positionRight = (state.positionRight != null) ? state.positionRight : null;
            frameManual.urz = (state.selectedUrz != null) ? state.selectedUrz.value : null;
            frameManual.aslmn = (state.frameDetails != null) ? state.frameDetails.aslmn : null;
            frameManual.aslmx = (state.frameDetails != null) ? state.frameDetails.aslmx : null;
            frameManual.mk = (state.selectedMk != null) ? state.selectedMk.text.text : null;
            frameManual.bal = (state.selectedBal != null) ? state.selectedBal.text.text : null;
            frameManual.lur = state.lur;

            frameManual.addOnPart = false;
            if (state.selectedFrameMounting != null) {
                frameManual.tnmk = state.selectedFrameMounting.blockNumber;
                frameManual.fraart = null;
                frameManual.fratyp = null;
                frameManual.urz = null;
                frameManual.urd = null;
                frameManual.positionUniversal = null;
                frameManual.positionLeft = null;
                frameManual.positionRight = null;
                frameManual.aslmn = null;
                frameManual.aslmx = null;
                frameManual.lur = null;
                frameManual.mk = null;
                frameManual.bal = null;
                frameManual.addOnPart = true;
            }


            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                kid: rootState.manualHome.kid,
                frameManual: frameManual,
                optionRetrofit: state.optionRetrofit,
                optionEmergencyStop: state.optionEmergencyStop,
                optionRopeGuard: state.optionRopeGuard,
                optionIsolation: state.optionIsolation,
                motorSelected: motorSelected,
                mtyp: mtyp,
                mbg: mbg,
                mfe: mfe,
                tsd: tsd,
                tb: null,
                sd: null,
                ra: null,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/insertOrUpdate_frameManual',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    if (response.data.status.statusCode.substring(0, 1) == '2') {
                        if (response.data.data.changedDataset == true && state.motorData == null) {
                            this.dispatch('manualHome/change_configurationOverviewsManualId_storeAction', response.data.data.configurationOverviewsManualId);
                        }
                        if (state.motorData != null && (rootState.inputsManual.motorCablesManualData == null || rootState.inputsManual.motorCablesManualData.hasOwnProperty('details') == false)) {
                            router.push({ params: { slug: 'cables' } })
                        }
                        else {
                            router.push('../manualStep/ManualHome');
                        }
                    }
                    else {
                    }
                })
                .catch(() => { })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })

        }
        else {
            if (state.motorData != null && (state.motorCablesManualData == null || state.motorCablesManualData.hasOwnProperty('details') == false)) {
                router.push({ params: { slug: 'cables' } })
            }
            else {
                router.push('../manualStep/ManualHome');
            }
        }
    },

    set_withoutFrame_storeAction({commit }) {
        this.dispatch('manualHome/delete_calculationFrame_storeAction');
        if (state.motorData != null && (state.motorCablesManualData == null || state.motorCablesManualData.hasOwnProperty('details') == false)) {
            router.push({ params: { slug: 'cables' } })
        }
        else {
            router.push('../manualStep/ManualHome');
        }
    },
}

const mutations = {
    change_motorData_storeMutation(state, payload) {
        state.motorData = payload;
    },
    change_tractionSheaveData_storeMutation(state, payload) {
        state.tractionSheaveData = payload;
    },
    change_motorAxleLoad_storeMutation(state, payload) {
        state.motorAxleLoad = payload;
    },
    change_motorSelection_storeMutation(state, payload) {
        state.selectedMotorElement = null;
        state.motorSelection = payload;
    },
    change_motorSelected_storeMutation(state, payload) {
        state.selectedMotorElement = null;
        for (let i = 0; i < state.motorSelection.length; i++) {
            state.motorSelection[i].selected = false;

            if (state.motorSelection[i].text == payload) {
                state.motorSelection[i].selected = true
                state.selectedMotorElement = state.motorSelection[i];
            }
        }
    },
    change_tractionSheaveDiameterSelection_storeMutation(state, payload) {
        state.selectedTractionSheaveDiameterElement = null;
        state.tractionSheaveDiameterSelection = payload;
    },
    change_tractionSheaveDiameterSelected_storeMutation(state, payload) {
        state.selectedTractionSheaveDiameterElement = null;
        for (let i = 0; i < state.tractionSheaveDiameterSelection.length; i++) {
            state.tractionSheaveDiameterSelection[i].selected = false;
            if (state.tractionSheaveDiameterSelection[i].text == payload.text && state.tractionSheaveDiameterSelection[i].tsd == payload.tsd) {
                state.tractionSheaveDiameterSelection[i].selected = true
                state.selectedTractionSheaveDiameterElement = state.tractionSheaveDiameterSelection[i];
            }
        }
    },

    change_frameMountingSelection_storeMutation(state, payload) {
        state.frameMountingSelection = payload;
    },
    change_frameMountingSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.frameMountingSelection.length; i++) {
            if (state.frameMountingSelection[i].blockNumber == payload && state.frameMountingSelection[i].selected == false) {
                state.frameMountingSelection[i].selected = true;
            }
            else {
                state.frameMountingSelection[i].selected = false;
            }
        }
    },
    change_selectedFrameMounting_storeMutation(state, payload) {
        state.selectedFrameMounting = payload;
    },
    change_fraartSelection_storeMutation(state, payload) {
        state.fraartSelection = payload;
    },
    change_fraartSelected_storeMutation(state, payload) {
        state.selectedFraart = null;
        for (let i = 0; i < state.fraartSelection.length; i++) {
            state.fraartSelection[i].selected = false;

            if (state.fraartSelection[i].text.text == payload) {
                state.fraartSelection[i].selected = true
                state.selectedFraart = state.fraartSelection[i];
            }
        }
    },
    change_selectedFraart_storeMutation(state, payload) {
        state.selectedFraart = payload;
    },
    change_fratypSelection_storeMutation(state, payload) {
        state.fratypSelection = payload;
    },
    change_fratypSelected_storeMutation(state, payload) {
        state.selectedFratyp = null;
        for (let i = 0; i < state.fratypSelection.length; i++) {
            state.fratypSelection[i].selected = false;

            if (state.fratypSelection[i].text.text == payload) {
                state.fratypSelection[i].selected = true
                state.selectedFratyp = state.fratypSelection[i];
            }
        }
    },
    change_selectedFratyp_storeMutation(state, payload) {
        state.selectedFratyp = payload;
    },

    change_urdSelection_storeMutation(state, payload) {
        state.urdSelection = payload;
    },
    change_urdSelected_storeMutation(state, payload) {
        state.selectedUrd = null;
        for (let i = 0; i < state.urdSelection.length; i++) {
            state.urdSelection[i].selected = false;

            if (state.urdSelection[i].value == payload) {
                state.urdSelection[i].selected = true
                state.selectedUrd = state.urdSelection[i];
            }
        }
    },
    change_selectedUrd_storeMutation(state, payload) {
        state.selectedUrd = payload;
    },
    change_positionInformation_storeMutation(state, payload) {
        state.positionInformation = payload;
    },
    change_positionUniversal_storeMutation(state, payload) {
        state.positionUniversal = payload;
    },
    change_positionLeft_storeMutation(state, payload) {
        state.positionLeft = payload;
    },
    change_positionRight_storeMutation(state, payload) {
        state.positionRight = payload;
    },
    change_frameDetails_storeMutation(state, payload) {
        state.frameDetails = payload;
    },
    change_urzSelection_storeMutation(state, payload) {
        state.urzSelection = payload;
    },
    change_pulleyDetails_storeMutation(state, payload) {
        state.pulleyDetails = payload;
    },
    change_urzSelected_storeMutation(state, payload) {
        state.selectedUrz = null;
        for (let i = 0; i < state.urzSelection.length; i++) {
            state.urzSelection[i].selected = false;

            if (state.urzSelection[i].value == payload) {
                state.urzSelection[i].selected = true
                state.selectedUrz = state.urzSelection[i];
            }
        }
    },
    change_selectedUrz_storeMutation(state, payload) {
        state.selectedUrz = payload;
    },
    change_lur_storeMutation(state, payload) {
        state.lur = payload;
    },
    change_optionRetrofit_storeMutation(state, payload) {
        state.optionRetrofit = payload;
    },
    change_optionEmergencyStop_storeMutation(state, payload) {
        state.optionEmergencyStop = payload;
    },
    change_optionRopeGuard_storeMutation(state, payload) {
        state.optionRopeGuard = payload;
    },
    change_optionIsolation_storeMutation(state, payload) {
        state.optionIsolation = payload;
    },
    change_balSelection_storeMutation(state, payload) {
        state.balSelection = payload;
    },
    change_balSelected_storeMutation(state, payload) {
        state.selectedBal = null;
        for (let i = 0; i < state.balSelection.length; i++) {
            if (payload.hasOwnProperty('text') && state.balSelection[i].text.text == payload.text.text) {
                if (payload.selected == false) {
                    state.balSelection[i].selected = true;
                    state.selectedBal = state.balSelection[i];
                }
                else {
                    state.balSelection[i].selected = false;
                }
            }
            else {
                state.balSelection[i].selected = false;
            }
        }
    },
    change_selectedBal_storeMutation(state, payload) {
        state.selectedBal = payload;
    },
    change_mkSelection_storeMutation(state, payload) {
        state.mkSelection = payload;
    },
    change_mkSelected_storeMutation(state, payload) {
        state.selectedMk = null;
        for (let i = 0; i < state.mkSelection.length; i++) {
            state.mkSelection[i].selected = false;

            if (state.mkSelection[i].text.text == payload) {
                state.mkSelection[i].selected = true
                state.selectedMk = state.mkSelection[i];
            }
        }
    },
    change_selectedMk_storeMutation(state, payload) {
        state.selectedMk = payload;
    },
    change_optionRetrofitAvailable_storeMutation(state, payload) {
        state.optionRetroAvailable = payload;
    },
    change_optionEmergencyStopAvailable_storeMutation(state, payload) {
        state.optionEmergencyStopAvailable = payload;
    },
    change_optionRopeGuardAvailable_storeMutation(state, payload) {
        state.optionRopeGuardAvailable = payload;
    },
    change_optionIsolationAvailable_storeMutation(state, payload) {
        state.optionIsolationAvailable = payload;
    },
    change_balAvailable_storeMutation(state, payload) {
        state.balAvailable = payload;
    },
    change_mkAvailable_storeMutation(state, payload) {
        state.mkAvailable = payload;
    },
}

export const frameManual = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations
}